import SignUpForm  from "../components/signupForm"
export default function SignUpPage(){
    return <SignUpForm/>
}